export class LoginFormData {
  constructor(email = "", password = "") {
    this.email = email;
    this.password = password;
  }
}

export class AuthResponse {
  constructor(status = false, data = null) {
    this.status = status;
    this.data = data;
  }
}

export class AdminUser {
  constructor(
    id = null,
    username = "",
    email = "",
    phone_number = "",
    role = "",
    is_verified = false,
    is_active = false
  ) {
    this.id = id;
    this.username = username;
    this.email = email;
    this.phone_number = phone_number;
    this.role = role;
    this.is_verified = is_verified;
    this.is_active = is_active;
  }
}